export const getUtmAndCampaignByAppendingToData = ($cookies, data) => {
  try {
    const utm = $cookies.get('utm_parameters')
    if (utm) {
      Object.keys(utm).forEach((key) => {
        data['utm_' + key] = utm[key]
      })
    }

    const campaign = $cookies.get('campaign_parameters')
    if (campaign) {
      Object.keys(campaign).forEach((key) => {
        data['campaign_' + key] = campaign[key]
      })
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e)
  }

  return data
}
